<div class="modal-header">
    <h5 class="modal-title">Afbeelding bekijken</h5>
    <div>
        <a (click)="close()" title="Annuleren" class="btn btn-transparent">Sluiten</a>
    </div>
</div>
<div class="modal-body p-5">
    <!-- <img [src]="imgBase64"> -->
    <image-cropper style="width: 80vw; height: 80vh;" [imageBase64]="imgBase64" [maintainAspectRatio]="true"
        [aspectRatio]="16 / 9" [disabled]="true"></image-cropper>
</div>
<div class="modal-footer">
    <div>
        <a (click)="replace()" title="Vervangen" class="btn btn-warning mr-2">Vervangen</a>
    </div>
    <div>
        <a (click)="delete()" title="Verwijderen" class="btn btn-danger">Verwijderen</a>
    </div>
</div>